// Angular Imports
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// Shared Imports
import { NotfoundComponent } from '@shared/components'
import { isLoggedGuard, hasRolesGuard } from '@shared/guards'
import { ERoles } from '@shared/models'

const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
	},
	{
		path: '',
		loadChildren: () => import('./modules/auth/auth.routing').then((r) => r.AUTH_ROUTES),
	},
	{
		path: 'dashboard',
		loadChildren: () =>
			import('./modules/dashboard/dashboard.routing').then((r) => r.DASHBOARD_ROUTES),
		canActivate: [isLoggedGuard, hasRolesGuard],
		data: {
			allowedRoles: [ERoles.user, ERoles.administrator],
		},
	},
	{
		path: 'alertsv2',
		canActivate: [isLoggedGuard],
		loadChildren: () =>
			import('./modules/dashboard/modules/alerts-v2/alerts-v2.routing').then(
				(r) => r.ALERTS_V2_ROUTES
			),
	},
	{
		path: 'notfound',
		component: NotfoundComponent,
		data: {
			returnBack: false,
			redirectTo: 'dashboard',
		},
	},
	{
		path: '**',
		component: NotfoundComponent,
		data: {
			returnBack: false,
			redirectTo: 'dashboard',
		},
	},
]

@NgModule({
	imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
